import { useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default function PricingPage() {
  const [averageCommission, setAverageCommission] = useState(10000)
  const [dealsPerYear, setDealsPerYear] = useState(1)

  const setupFee = 297
  const monthlyFee = 297
  const annualCost = setupFee + (monthlyFee * 12)
  const annualRevenue = averageCommission * dealsPerYear
  const annualROI = annualRevenue - annualCost
  const roiMultiple = (annualRevenue / annualCost).toFixed(1)

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero */}
      <section className="section bg-gradient-to-br from-primary-50 to-blue-100">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Simple, Transparent Pricing
          </h1>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            One simple price. No hidden fees. No long-term contracts. Cancel anytime.
          </p>
        </div>
      </section>

      {/* Pricing Card */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto">
            <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-3xl p-12 text-white shadow-2xl">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold mb-2">HellaBots Pro</h2>
                <p className="text-primary-100">Everything you need to capture leads 24/7</p>
              </div>

              <div className="flex items-baseline justify-center mb-8">
                <span className="text-5xl font-bold">${monthlyFee}</span>
                <span className="text-xl ml-2 text-primary-100">/month</span>
              </div>

              <div className="text-center mb-8">
                <p className="text-primary-100">+ ${setupFee} one-time setup fee</p>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>24/7 AI chatbot on your website</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Automatic lead qualification</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>HOT lead detection (pre-approved buyers, motivated sellers)</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Calendly integration for automatic appointment booking</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Instant email notifications for new leads</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Custom branding (your colors, logo, name)</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Analytics dashboard with lead tracking</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Deploy in 5 minutes - no coding required</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-green-300 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Cancel anytime, no long-term commitment</span>
                </div>
              </div>

              <Link to="/configure" className="block w-full bg-white text-primary-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-colors text-center text-lg">
                Get Started Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ROI Calculator */}
      <section className="section bg-gray-50">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                ROI Calculator
              </h2>
              <p className="text-xl text-gray-600">
                See how quickly HellaBots pays for itself
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Average Commission per Deal
                  </label>
                  <div className="relative">
                    <span className="absolute left-4 top-3 text-gray-500">$</span>
                    <input
                      type="number"
                      value={averageCommission}
                      onChange={(e) => setAverageCommission(Number(e.target.value))}
                      className="w-full pl-8 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      min="0"
                      step="1000"
                    />
                  </div>
                  <p className="text-sm text-gray-500 mt-2">Typical: $8,000 - $15,000</p>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Deals from Chatbot Leads per Year
                  </label>
                  <input
                    type="number"
                    value={dealsPerYear}
                    onChange={(e) => setDealsPerYear(Number(e.target.value))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    min="0"
                    step="1"
                  />
                  <p className="text-sm text-gray-500 mt-2">Conservative estimate: 1-2 deals</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-2">Annual Revenue</p>
                    <p className="text-3xl font-bold text-gray-900">
                      ${annualRevenue.toLocaleString()}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-2">Annual Cost</p>
                    <p className="text-3xl font-bold text-gray-900">
                      ${annualCost.toLocaleString()}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-2">Net Profit</p>
                    <p className="text-3xl font-bold text-primary-600">
                      ${annualROI.toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="mt-8 text-center">
                  <div className="inline-block bg-primary-600 text-white px-8 py-4 rounded-full">
                    <p className="text-sm font-semibold mb-1">Return on Investment</p>
                    <p className="text-4xl font-bold">{roiMultiple}x</p>
                  </div>
                </div>

                <p className="text-center text-gray-600 mt-6 text-lg">
                  {dealsPerYear === 1 ? (
                    <>Just <strong>one deal</strong> from your chatbot and you're profitable!</>
                  ) : (
                    <>With <strong>{dealsPerYear} deals</strong>, you'll make ${annualROI.toLocaleString()} in profit!</>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Manual vs Automated Lead Capture
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Without HellaBots */}
              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Without HellaBots
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="text-gray-700">Miss leads outside business hours</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="text-gray-700">Manual lead qualification takes time</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="text-gray-700">Back-and-forth to schedule meetings</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="text-gray-700">Leads get cold while you're busy</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="text-gray-700">No lead tracking or analytics</span>
                  </div>
                </div>
              </div>

              {/* With HellaBots */}
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl p-8 border-2 border-primary-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  With HellaBots
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700"><strong>Capture leads 24/7</strong>, never miss a prospect</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700"><strong>AI qualifies instantly</strong>, flags HOT leads</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700"><strong>Auto-book appointments</strong> directly to your calendar</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700"><strong>Instant response</strong> keeps leads hot</span>
                  </div>
                  <div className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700"><strong>Full analytics</strong> and performance tracking</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section bg-primary-600 text-white">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold mb-6">
            Start Capturing Leads Today
          </h2>
          <p className="text-xl mb-8 text-primary-100 max-w-2xl mx-auto">
            Join successful agents who never miss a lead. Setup takes 5 minutes.
          </p>
          <Link to="/configure" className="bg-white text-primary-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-colors inline-block text-lg">
            Get Started Now
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  )
}
